import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Box from '@mui/material/Box'
import {styled} from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import Slide from '@mui/material/Slide'
import {TransitionProps} from '@mui/material/transitions'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import Tooltip from '@mui/material/Tooltip'
import ClickAwayListener from '@mui/material/ClickAwayListener'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

interface AssetModalProps {
  filename: string
  based_uri: string
  filetype: string
  id: string
  last_revision_date: string
  setSelectedAsset: any
}

const ListItem = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const AssetModal: React.FC<AssetModalProps> = props => {
  const [open, setOpen] = React.useState(true)
  const [tooltipOpen, setTooltipOpen] = React.useState(false)
  const {last_revision_date, setSelectedAsset, filename, based_uri, filetype, id} = props
  const lastUpdated = new Date(last_revision_date).toDateString()

  const handleClose = () => {
    setSelectedAsset(null)
    setOpen(false)
  }

  const copyToClipboard = () => {
    setTooltipOpen(true)
    navigator.clipboard.writeText(based_uri)
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent sx={{padding: '24px'}}>
        <DialogContentText id="alert-dialog-slide-description">
          <img
            alt={filename || `Asset ${id}`}
            src={based_uri}
            style={{width: '100%', height: '100%', maxHeight: '500px'}}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box sx={{width: '100%'}}>
          <Box sx={{margin: '16px', padding: '4px', backgroundColor: '#eee'}}>
            <ListItem>
              <div>URL</div>
              <div>
                .../{filename}.{filetype}
                <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    onClose={() => setTooltipOpen(false)}
                    open={tooltipOpen}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title="Copied!"
                    placement="top"
                  >
                    <IconButton aria-label="delete" onClick={copyToClipboard}>
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                </ClickAwayListener>
              </div>
            </ListItem>
            <ListItem>
              <div>Last Updated</div>
              <div>{lastUpdated}</div>
            </ListItem>
            <ListItem>
              <div>Filetype</div>
              <div>{filetype}</div>
            </ListItem>
          </Box>
          <Button onClick={handleClose} sx={{marginRight: '8px', float: 'right'}}>
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AssetModal
